module.exports = __webpack_public_path__ + "img/banner.1f7185e.png";